module.exports = __webpack_public_path__ + "static/img/Permiso(21).f65a0ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(21).jpg
// module id = WmV/
// module chunks = 0